import { useEffect } from 'react'
import dayjs from 'utils/dayjs'
import { UseEventsForArtistOptions } from '../types'
import { DATE_FORMAT } from '~constants'
import { calendarDates } from '../utils'
import { useEventsStore } from 'store/useEventsStore'
import { CALENDAR_EDP_NUMBER_OF_MONTHS } from 'constants/calendar'

export const useEventsForArtist = (options: UseEventsForArtistOptions) => {
  // Destructure options with default values
  const { startDate = new Date(), artist, endDate } = options

  // Store to manage state and actions
  const { fetchEventsForSingleArtist, setStartDate, setEndDate, setArtists, loading, selectedMonthForSingleArtist } =
    useEventsStore()

  useEffect(() => {
    if (!artist) return

    let reqStartDate = startDate
    let reqEndDate = endDate

    if (selectedMonthForSingleArtist !== null) {
      reqStartDate = dayjs(selectedMonthForSingleArtist?.value, DATE_FORMAT.MONTH_YEAR_LABEL).startOf('month')
      reqEndDate = dayjs(selectedMonthForSingleArtist?.value, DATE_FORMAT.MONTH_YEAR_LABEL).add(
        CALENDAR_EDP_NUMBER_OF_MONTHS,
        'months'
      )
    }

    const { startDate: calendarStartDate, endDate: endRange } = calendarDates(reqStartDate, reqEndDate)

    // Set state in store
    setStartDate(calendarStartDate)
    setEndDate(dayjs(endRange, DATE_FORMAT.SHORT_DATE_NO_SEPRATOR).toDate())
    setArtists([artist])

    // Fetch events from EventEngine API
    fetchEventsForSingleArtist(
      dayjs(calendarStartDate, DATE_FORMAT.SHORT_DATE_NO_SEPRATOR).toDate(),
      dayjs(endRange, DATE_FORMAT.SHORT_DATE_NO_SEPRATOR).toDate(),
      [artist],
      artist?.artistId
    )
  }, [startDate, artist, selectedMonthForSingleArtist])

  return {
    loading
  }
}
